import { RaButtonAddToCart } from '../RaButtonAddToCart/RaButtonAddToCart'
import { RaKeyfactWithoutIcon } from '../RaKeyfactWithoutIcon/RaKeyfactWithoutIcon'

import styles from './ra-day-by-day-insert-activities.module.scss'

import { RaImage, RaRichText } from '@/components/core/index.core'
import { AdditionalServiceItemProps } from '@/typings/index.typings'
import { translate } from '@/utilities/helpers/translate.helpers'

export const RaDayByDayInsertActivitiesModal = (item: AdditionalServiceItemProps) => {
  const gallery = item.slideshow.slice(0, 3)
  return (
    <div className={styles['modal']}>
      <ul className={styles['content__list']}>
        <RaKeyfactWithoutIcon
          item={{
            title: translate('TRIP_PRICE'),
            text: item.traveling_price,
            remove_from_detail: false,
            teaser_checkbox: false,
          }}
        />
        <RaKeyfactWithoutIcon
          item={{
            title: translate('TRIP_DEPARTURE'),
            text: item.services,
            remove_from_detail: false,
            teaser_checkbox: false,
          }}
        />
      </ul>
      <div className={styles['modal__gallery']}>
        {gallery.map((img, i) => (
          <RaImage
            key={i}
            image={img}
          />
        ))}
      </div>
      <RaRichText content={item.content} />
      <RaButtonAddToCart item={item} />
    </div>
  )
}
